import image from '../../assets/images/image.png';

export default [
    {
        "specialist": "Dr. Rubens Belfort Jr.",
        "avatar": image,
        "title": "MD, PhD, Presidente da Academia Nacional de Medicina",
        "text": "A Eyecare Health visa aumentar o acesso à saúde ocular e trazer mais valia aos procedimentos, transmitindo este valor aos pacientes, mas também aos outros blocos do segmento: médicos, clínicas, empresas, operadoras de saúde, indústria e farmácias." 
    }
]